import { Connection } from 'src/ui/graph/types';
import * as copy from 'src/ui/templates/copy';

export const getEndpointUrl = (connection: Connection) => {
  if (connection.isAllocating) {
    if (connection.stripeSubscription?.isExpired) {
      return copy.components.endpoints.endpoint.isExpired;
    }
    if (connection.stripeSubscription?.isWaitingForPayment) {
      return copy.components.endpoints.endpoint.isWaitingForPayment;
    }
    return copy.components.endpoints.endpoint.isAllocating;
  }

  return connection.endpoint;
};
